import apiClient from './client'

/**
 * API client per l'autenticazione.
 * 
 * Gestisce tutte le chiamate relative a:
 * - Login/Logout
 * - Refresh token
 * - Profilo utente
 * - Cambio password
 */
export const authApi = {
  /**
   * Effettua il login e ottiene i token JWT.
   * 
   * @param {string} username - Nome utente
   * @param {string} password - Password
   * @returns {Promise} - { access, refresh }
   */
  login: (username, password) => 
    apiClient.post('/users/token/', { username, password }),

  /**
   * Rinnova l'access token usando il refresh token.
   * 
   * @param {string} refreshToken - Refresh token valido
   * @returns {Promise} - { access }
   */
  refreshToken: (refreshToken) => 
    apiClient.post('/users/token/refresh/', { refresh: refreshToken }),

  /**
   * Ottiene il profilo dell'utente corrente.
   * 
   * @returns {Promise} - Dati profilo utente
   */
  getProfile: () => 
    apiClient.get('/users/me/'),

  /**
   * Aggiorna il profilo dell'utente corrente.
   * 
   * @param {Object} data - Dati da aggiornare
   * @returns {Promise} - Profilo aggiornato
   */
  updateProfile: (data) => 
    apiClient.patch('/users/me/', data),

  /**
   * Cambia la password dell'utente corrente.
   * 
   * @param {string} oldPassword - Password attuale
   * @param {string} newPassword - Nuova password
   * @param {string} newPasswordConfirm - Conferma nuova password
   * @returns {Promise}
   */
  changePassword: (oldPassword, newPassword, newPasswordConfirm) => 
    apiClient.post('/users/cambio_password/', {
      old_password: oldPassword,
      new_password: newPassword,
      new_password_confirm: newPasswordConfirm,
    }),
}

export default authApi
